var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgA8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#6F00FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1658 9.84207C20.8241 9.5004 20.2324 9.73373 20.2324 10.2087V13.1171C20.2324 14.3337 21.2658 15.3421 22.5241 15.3421C23.3158 15.3504 24.4158 15.3504 25.3574 15.3504C25.8324 15.3504 26.0824 14.7921 25.7491 14.4587C24.5491 13.2504 22.3991 11.0754 21.1658 9.84207Z",
    fill: "#D9CDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.084 16.492H22.6757C20.7007 16.492 19.0923 14.8837 19.0923 12.9087V10.5003C19.0923 10.042 18.7173 9.66699 18.259 9.66699H14.7257C12.159 9.66699 10.084 11.3337 10.084 14.3087V21.692C10.084 24.667 12.159 26.3337 14.7257 26.3337H21.2757C23.8423 26.3337 25.9173 24.667 25.9173 21.692V17.3253C25.9173 16.867 25.5423 16.492 25.084 16.492ZM17.584 22.792H14.2507C13.909 22.792 13.6257 22.5087 13.6257 22.167C13.6257 21.8253 13.909 21.542 14.2507 21.542H17.584C17.9257 21.542 18.209 21.8253 18.209 22.167C18.209 22.5087 17.9257 22.792 17.584 22.792ZM19.2507 19.4587H14.2507C13.909 19.4587 13.6257 19.1753 13.6257 18.8337C13.6257 18.492 13.909 18.2087 14.2507 18.2087H19.2507C19.5923 18.2087 19.8757 18.492 19.8757 18.8337C19.8757 19.1753 19.5923 19.4587 19.2507 19.4587Z",
    fill: "#D9CDFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA8);
export default __webpack_public_path__ + "static/media/a8.64d1fbc885c03b59c12067d2f545efb0.svg";
export { ForwardRef as ReactComponent };